module.exports = __webpack_public_path__ + "img/staff-photo-main.acde194.webp";